import { TariffDTO } from '@class/commons/unit.model';

export class UnitDetails {
  public id: string;
  public name: string;
  public address: string;
  public nmi: string;
  public contact_phone: string;
  public onlineStatus: string;
  public disable_alarms: boolean | null;
  public tariff_options: Array<TariffDTO>;
  public tariffs: number[];
  public state: string;
  public city: string;
  public postcode: string;
  public country: string;
  public latitude: number;
  public longitude: number;
  public timezone: string;
  public external_identifier: string;
  constructor(
    id = '',
    name = '',
    address = '',
    nmi = '',
    contact_phone = '',
    online_status = '',
    disable_alarms = null,
    tariff_options = [],
    tariffs = [],
    state = '',
    city = '',
    postcode = '',
    country = '',
    latitude = 0,
    longitude = 0,
    timezone = '',
    external_identifier = '',
  ) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.nmi = nmi;
    this.contact_phone = contact_phone;
    this.onlineStatus = online_status;
    this.disable_alarms = disable_alarms;
    this.tariff_options = tariff_options;
    this.tariffs = tariffs;
    this.state = state;
    this.city = city;
    this.postcode = postcode;
    this.country = country;
    this.latitude = latitude;
    this.longitude = longitude;
    this.timezone = timezone;
    this.external_identifier = external_identifier;
  }
}
